import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Check from 'components/material-symbol/icons/Check'

const useCheckStepIconStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: theme.palette.primary.main,
    '& span': {
      color: theme.palette.primary.main,
    },
  },
  circle: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
  completed: {
    color: theme.palette.primary.main,
    zIndex: 1,
    fontSize: 18,
  },
}))

function CheckStepIcon(props) {
  const { active, completed } = props
  const classes = useCheckStepIconStyles()

  const activeClass = active ? classes.active : ''
  return (
    <div className={`${classes.root} ${activeClass}`}>
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  )
}

export default CheckStepIcon
